import { UseStore } from '@eastcoal/common/types/zustand'
import { useShallowStore } from '@eastcoal/common/utils/zustand'

import { registerStore } from '../store'
import { RegisterStore } from '../store/interface'

export const useRegisterStore: UseStore<RegisterStore> = selector => {
  return useShallowStore(registerStore, selector)
}
